export const EvuDefaultStyles = {
  colors: {
    primary: '#84A6FF',
    primary50: '#c5d2fe',
    primary25: '#e2e9ff',
    primary10: '#f3f6ff',
    secondary: '#3C235D',
    secondary50: '#9d91ad',
    secondary25: '#cec8d6',
    secondary10: '#ebe9ee',
    success: '#64C89E',
    error: '#FF8365',
    warning: '#FFC969',
    info: '#EBEEF1',
    gray1: '#F7F8F7',
    gray2: '#CFCFCF',
    gray3: '',
    gray4: '#696969',
    black: '#000000',
    white: '#FFFFFF',
  },
  fonts: {
    headings: 'Poppins, Montserrat, Verdana, sans-serif',
    body: 'Roboto, Arial, sans-serif'
  }
};
